<div id="statisticsArea">
	<!-- <div class="titleBox">
		<h2>共創服務價值​</h2>
		<p>我們以數據為基石，提供打造更智慧、更高效的解決方案，致力推動社會發展與創新。</p>
	</div>

	<div class="statisticsBox">
		<div class="noDisplayCard">
			<div class="noBox">
				<span #flip class="organization">00</span>
			</div>
			<div class="textBox">
				<p class="serveType">政府機關</p>
				<div class="horizontal-divider"></div>
				<p class="typeDesc">重要主管機關服務數量</p>
			</div>
		</div>
		<div class="noDisplayCard">
			<div class="noBox">
				<span #flip class="project">00</span>
			</div>
			<div class="textBox">
				<p class="serveType">服務專案</p>
				<div class="horizontal-divider"></div>
				<p class="typeDesc">中長期合作專案服務數量</p>
			</div>
		</div>
		<div class="noDisplayCard">
			<div class="noBox">
				<span #flip class="solution">000</span>
			</div>
			<div class="textBox">
				<p class="serveType">解決方案</p>
				<div class="horizontal-divider"></div>
				<p class="typeDesc">為客戶完善解決問題數量</p>
			</div>
		</div>
	</div> -->
	<div class="iframeBox">
		<iframe
			src="https://www.youtube.com/embed/KjqJXy230_E?autoplay=1&rel=0"
			frameborder="0"
			allowfullscreen
		></iframe>
	</div>
</div>
